import { render, staticRenderFns } from "./section-role-node.vue?vue&type=template&id=c05d634c&"
import script from "./section-role-node.vue?vue&type=script&lang=js&"
export * from "./section-role-node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports